import { Backdrop, CircularProgress, useTheme } from '@mui/material';
import { getStyled } from './styles';

const BackdropLoading = () => {
  const theme = useTheme();
  const classes = getStyled(theme);

  return (
    <Backdrop style={classes.backdrop} open={true}>
      <CircularProgress color='inherit' />
    </Backdrop>
  );
};

export default BackdropLoading;
